module.exports = __webpack_public_path__ + "media/images/flags/4x3/twn-0e99b0ca012aed2e6d89b3005eeb240e.svg";